import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { ConfirmationPageSuccessComponent } from '../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { BusyIndicatorComponent } from '../../../../shared-components/busy-indicator/busy-indicator.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminService } from '../../../../services/Admin.service';
import { Router } from '@angular/router';
import { DataService } from '../../../../services/data.service';

@Component({
  selector: 'app-change-password-v',
  templateUrl: './change-password-v.component.html',
  styleUrls: ['./change-password-v.component.scss']
})
export class ChangePasswordVComponent implements OnInit, OnDestroy {
  oldPassword: string;
  newPassword: string;
  newConfirmPassword: string;
  isOldPasswordMatched: boolean;
  isNewPwdPreviousPwdSame: boolean;
  isComparePasswordMatched: boolean;
  public errorMsg: string;
  public successMsg: string;
  public showSuccessConfirmation = false;
  public showFailConfirmation = false;
  alive = true;
  constructor(private adminSvc: AdminService,
    private dataSvc: DataService,
    private router: Router,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
  }

  public checkPassword(frmChgPwd: NgForm) {
    this.adminSvc.CheckPassword(this.oldPassword)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        frmChgPwd.controls['oldPassword'].setErrors(null);
        this.isOldPasswordMatched = true;
            },
      err => {
        frmChgPwd.controls['oldPassword'].setErrors({'incorrect' : true});
        this.isOldPasswordMatched = false;
        }
    );
  }

  public compareOld(frmChgPwd: NgForm) {
    if (this.oldPassword === this.newPassword) {
      frmChgPwd.controls['newPassword'].setErrors({'incorrect' : true});
      this.isNewPwdPreviousPwdSame = true;
    } else {
      frmChgPwd.controls['newPassword'].setErrors(null);
      this.isNewPwdPreviousPwdSame = false;
    }
  }

  comparePasswords(frmChgPwd: NgForm) {
    if (this.newPassword === this.newConfirmPassword) {
      frmChgPwd.controls['newConfirmPassword'].setErrors(null);
      this.isComparePasswordMatched = true;
    } else {
      frmChgPwd.controls['newConfirmPassword'].setErrors({'incorrect' : true});
      this.isComparePasswordMatched = false;
    }
  }

  goToVendorHome(event) {
    this.router.navigate(['/pages/vendor/myvendor/home']);
  }

  close(event) {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  onSubmit(frmChgPwd: NgForm) {
    this.errorMsg = null;
    console.log('inside change password0');
    console.log(this.dataSvc.userDisplayInfo);
    console.log(this.dataSvc.userDisplayInfo.bearerToken);
    this.successMsg = null;
    this.spinner.show();
    this.adminSvc.ChangePassword(this.newPassword, this.oldPassword, this.dataSvc.userDisplayInfo.bearerToken)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
         this.spinner.hide();
         this.showSuccessConfirmation = true;
         this.showFailConfirmation = false;
         this.successMsg = 'You have successfully updated your password for this account.';
               },
      err => {
        this.spinner.hide();
        this.showSuccessConfirmation = false;
        this.showFailConfirmation = true;
        this.errorMsg = err;
        }

    );
  }

  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-settings-v/change-password-v/change-password-v.component.ts